<template>
  <div class="turnos-container">
    <v-bottom-navigation v-show="alert" fixed>
      <v-btn>
        <v-chip
          class="ma-2"
          close
          color="primary"
          text-color="white"
          @click:close="cancelaCopia"
          >Está copiando o reprogramando un turno</v-chip
        >
      </v-btn>
    </v-bottom-navigation>
    <v-card>
      <v-toolbar dark color="primary">
        <v-toolbar-title>Agenda Semanal</v-toolbar-title>
      </v-toolbar>
      <v-row class="ml-2 mr-1 mb-1">
        <v-col cols="12" md="4" sm="4">
          <v-select
            :items="profs"
            item-text="nombre"
            item-value="idCancha"
            menu-props="auto"
            label="Cancha"
            hide-details
            prepend-icon="mdi-account"
            v-model="prof"
            :disabled="isLoading"
            class="mt-6"
            ref="vselect"
            no-data-text="No hay canchas registradas"
          ></v-select>
        </v-col>
      </v-row>
      <!-- <v-switch v-model="singleExpand" label="Single expand" class="mt-2"></v-switch> -->
      <v-toolbar flat class="pt-4">
        <v-row>
          <v-btn
            class="ml-4 mr-2"
            max-width="40px"
            min-width="40px"
            @click="retrocederSemana"
            tile
            color="blue"
            dark
          >
            <v-icon large>mdi-arrow-left-bold</v-icon>
          </v-btn>

          <v-menu
            v-model="menu2"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="dateFormatted"
                label="Semana del"
                @blur="date = date"
                readonly
                v-on="on"
                class="shrink"
                style="width: 88px"
              ></v-text-field>
            </template>

            <v-date-picker
              v-model="date"
              @input="menu2 = false"
              locale="es-ar"
              :first-day-of-week="1"
              @change="armarTurnos"
              :allowed-dates="allowedDates"
            ></v-date-picker>
          </v-menu>

          <v-btn
            class="ml-2"
            max-width="40px"
            min-width="40px"
            @click="avanzarSemana"
            tile
            color="blue"
            dark
          >
            <v-icon large>mdi-arrow-right-bold</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
        </v-row>
      </v-toolbar>

      <v-card-title>
        <v-row class="mt-0 pt-0 mb-0 pb-0">
          <v-col cols="12" class="mt-0 pt-0 mb-0 pb-0">
            <v-checkbox
              v-model="refrescarPantalla"
              label="Refresco Automático de Pantalla"
              color="primary"
              dense
            ></v-checkbox>
          </v-col>
          <v-col cols="12" class="mt-0 pt-0 mb-0 pb-0">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Buscar turnos en la semana"
              single-line
              hide-details
              dense=""
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-title>

      <div
        v-for="(turnos, dia) in turnosPorDia"
        :key="dia"
        class="dia-wrapper mb-6"
      >
        <div class="d-flex justify-center dia-sticky">
          <v-chip
            style="max-width: 80%; display: flex; justify-content: center"
            color="primary"
            dark
            class="mb-2 dia-chip"
          >
            {{ getDiaSemana(dia) }} {{ dia }}
          </v-chip>
        </div>
        <v-data-table
          :headers="headers"
          :items="turnos"
          :search="search"
          :hide-default-footer="true"
          :loading="isLoading"
          item-key="id"
          locale="es-ar"
          class="elevation-1 mytable"
          :disable-sort="true"
          :items-per-page="500"
        >
          <template v-slot:item.hora="{ item }">
            <v-chip
              :color="
                getColor(
                  item.hora,
                  item.paciente,
                  item.entreTurno,
                  item.estadoTurno,
                  item.observacionesTurno,
                  item.idObraSocial,
                )
              "
              dark
              >{{ item.hora }}</v-chip
            >
          </template>

          <template v-slot:item.paciente="{ item }">
            <v-chip
              :color="
                getColorPaciente(
                  item.hora,
                  item.paciente,
                  item.entreTurno,
                  item.estadoTurno,
                  item.observacionesTurno,
                  item.idObraSocial,
                )
              "
              dark
            >
              {{ item.paciente }}
            </v-chip>
          </template>

          <template v-slot:item.duracion="{ item }">
            <v-chip
              x-small
              outlined
              :color="
                getColorPaciente(
                  item.hora,
                  item.paciente,
                  item.entreTurno,
                  item.estadoTurno,
                  item.observacionesTurno,
                  item.idObraSocial,
                )
              "
              class="duracion-chip"
            >
              {{
                item.idTurno === 0
                  ? formatMinutos(item.tiempoTurno)
                  : formatDuracion(item.cantIntervalos, item.tiempoTurno)
              }}
            </v-chip>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-show="
                    item.paciente == 'Disponible' &&
                    item.hora != 'Feriado' &&
                    item.hora != 'Cancelación'
                  "
                  small
                  rounded
                  color="green"
                  dark
                  @click.stop="nuevoTurno(item, 0)"
                >
                  <v-icon class="mr-2" dark left> mdi-calendar </v-icon>Nuevo
                  Turno
                </v-btn>
              </template>
              <span>Nuevo Turno</span>
            </v-tooltip>

            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-show="
                    item.paciente != 'Disponible' &&
                    item.hora != 'Feriado' &&
                    item.observacionesTurno != 'Cancelación' &&
                    copiar != 1
                  "
                  medium
                  color="purple"
                  class="mr-3"
                  v-on="on"
                  v-bind="attrs"
                  @click.stop="editarTurno(item)"
                  >mdi-pencil</v-icon
                >
              </template>
              <span>Editar Turno</span>
            </v-tooltip>

            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  medium
                  class="mr-3"
                  v-show="
                    item.paciente != 'Disponible' &&
                    item.hora != 'Feriado' &&
                    item.observacionesTurno != 'Cancelación' &&
                    copiar != 1 &&
                    $store.state.usuario.roles.some((rol) =>
                      [1, 3].includes(rol.idRol),
                    )
                  "
                  v-on="on"
                  color="red"
                  v-bind="attrs"
                  @click.stop="deleteItem(item)"
                  >mdi-delete</v-icon
                >
              </template>
              <span>Eliminar Turno</span>
            </v-tooltip>

            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  medium
                  class="mr-3"
                  v-show="
                    item.paciente != 'Disponible' &&
                    item.hora != 'Feriado' &&
                    item.observacionesTurno != 'Cancelación' &&
                    copiar != 1
                  "
                  v-on="on"
                  color="grey"
                  v-bind="attrs"
                  @click.stop="nuevoTurno(item, 1)"
                  >mdi-calendar-multiple</v-icon
                >
              </template>
              <span>Entre Turno</span>
            </v-tooltip>

            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  medium
                  class="mr-3"
                  color="#d35400"
                  v-show="
                    item.paciente != 'Disponible' &&
                    item.hora != 'Feriado' &&
                    item.observacionesTurno != 'Cancelación' &&
                    copiar != 1 &&
                    (roles.some((o) => o.idRol === 1) ||
                      roles.some((o) => o.idRol === 5))
                  "
                  v-on="on"
                  v-bind="attrs"
                  @click.stop="cobrar(item)"
                  >mdi-currency-usd</v-icon
                >
              </template>
              <span>Consumos</span>
            </v-tooltip>

            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-show="
                    item.paciente != 'Disponible' &&
                    item.hora != 'Feriado' &&
                    item.observacionesTurno != 'Cancelación' &&
                    copiar != 1
                  "
                  medium
                  color="black"
                  class="mr-3"
                  v-on="on"
                  v-bind="attrs"
                  @click="copiarReprogramar(item)"
                  >mdi-content-duplicate</v-icon
                >
              </template>
              <span>Copiar / Reprogramar Turno</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </div>
      <v-alert
        color="blue"
        dark
        outlined
        v-if="listaTurnos.length == 0 && !isLoading"
        class="mb-0 mt-2"
        >No hay agendas configuradas para esta semana. <br />
        <br />
        <v-btn
          v-if="$store.getters.tieneRol(9)"
          color="warning"
          @click="
            $router.push({
              name: 'cronogramas',
              params: { idCancha: prof },
            })
          "
          >Configurar Cronograma</v-btn
        ></v-alert
      >
      <v-card-title>
        <v-btn class="mb-2" dark color="#24232d" @click="salir">
          <v-icon left>mdi-arrow-left</v-icon>
          Volver
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="success"
          @click="mostrarCronogramas"
          dark
          class="mb-2 mr-2"
          v-on="on"
          >Ver Cronogramas Vigentes</v-btn
        >
        <v-btn
          color="primary"
          @click="mostrarColores"
          dark
          class="mb-2"
          v-on="on"
          >Ver reseña de íconos y colores</v-btn
        >
      </v-card-title>
      <NuevoTurno
        :visible="showNuevoTurno"
        :dia="editedItem.fechaTurnoString"
        :hora="horaTurno"
        :idProfesional="prof"
        :tiempoTurno="editedItem.tiempoTurno"
        :entreTurno="entreTurno"
        :tipoTurno="editedItem.tipoTurno"
        @close="showNuevoTurno = false"
        @turnoRegistrado="turnoRegistrado"
      ></NuevoTurno>
      <EditarTurno
        :visible="showEditarTurno"
        :dia="editedItem.fechaTurnoString"
        :hora="editedItem.hora"
        :idProfesional="prof"
        :tiempoTurno="editedItem.tiempoTurno"
        :idTurno="editedItem.idTurno"
        :observacionesPaciente="editedItem.observacionesPaciente"
        @close="showEditarTurno = false"
        @turnoModificado="turnoModificado"
      ></EditarTurno>
      <Colores :visible="showColores" @close="showColores = false"></Colores>
      <VerCronogramas
        :visible="showCronogramas"
        :prof="prof"
        @close="showCronogramas = false"
      ></VerCronogramas>
      <ConsumosWrapper
        :visible="showNuevoCobro"
        :idTurno="editedItem.idTurno"
        :estadoTurno="editedItem.estadoTurno"
        :pacienteTurno="editedItem.paciente"
        :idProfesional="prof"
        :idPacienteTurno="editedItem.idPaciente"
        :celular="editedItem.celular"
        :nombrePaciente="editedItem.paciente"
        :fechaTurno="editedItem.fechaTurnoString"
        :tipoTurno="{
          nombre: editedItem.nombreTipoTurno,
          total: editedItem.totalTipoTurno,
        }"
        @recargarLista="armarTurnos"
        @close="cierraNuevoCobro()"
      ></ConsumosWrapper>
      <ModalMotivoBaja
        :visible="showModalMotivoBaja"
        @confirmar="confirmarMotivoBaja"
        @close="cerrarModalMotivoBaja"
      />
    </v-card>
  </div>
</template>
<style scoped>
::v-deep .v-data-table__empty-wrapper {
  display: none;
}
.loader {
  border: 4px solid #f3f3f3; /* Light grey */
  border-top: 4px solid #3498db; /* Blue */
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.turnos-container {
  margin-top: 3.8rem;
}

@media (max-width: 768px) {
  ::v-deep .v-data-table thead {
    display: none;
  }

  ::v-deep .v-data-table tr {
    margin-bottom: 12px;
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 8px;
  }

  ::v-deep .v-data-table td {
    margin-bottom: 12px;
    padding: 8px;
  }
  ::v-deep .v-data-table td .v-btn {
    min-height: 26px !important;
    margin-bottom: 1rem;
  }
}
.dia-sticky {
  position: sticky;
  top: 56px; /* ajustá según tu toolbar */
  z-index: 3;
  display: flex;
  justify-content: center;
  background: white;
  padding: 6px 0;
}

.dia-chip {
  max-width: 80%;
  justify-content: center;
}

:deep(.theme--light.v-data-table)
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > td:last-child,
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > th:last-child {
  border-bottom: 0;
}

:deep(.v-data-table)
  > .v-data-table__wrapper
  .v-data-table__mobile-row:first-child {
  margin-top: 1rem;
}
</style>

<script>
import EditarTurno from "./EditarTurno.vue";
import NuevoTurno from "./NuevoTurno.vue";
import Colores from "./Colores.vue";
import VerCronogramas from "./VerCronogramasActivos.vue";
import axios from "@/axios-auth";
import router from "@/router";
import { showAlert } from "@/utils/toast";
import ConsumosWrapper from "../Consumos/ConsumosWrapper.vue";
import ModalMotivoBaja from "./ModalMotivoBaja.vue";
export default {
  name: "GestionTurnos",

  data() {
    return {
      dialog: false,
      alert: false,
      showModalMotivoBaja: false,
      turnoABorrar: null,
      roles: [],
      showNuevoTurno: false,
      showEditarTurno: false,
      showColores: false,
      showCronogramas: false,
      showNuevoCobro: false,
      valid: true,
      copiar: 0,
      name: "",
      refrescarPantalla: null,
      interval: null,
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => (v && v.length <= 10) || "Name must be less than 10 characters",
      ],
      email: "",
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      select: null,
      isLoading: false,
      expanded: [],
      singleExpand: false,
      search: "",
      headers: [
        {
          text: "Hora",
          align: "start",
          filterable: false,
          width: "150",
          value: "hora",
        },
        { text: "Jugador", value: "paciente" },
        // {text: "Turnos Consecutivos", align:"center",value:"intervalos"},
        { text: "Duración", value: "duracion", sortable: false },
        { text: "Acciones", value: "actions", sortable: false },
      ],
      headersLength: {
        type: Number,
      },
      editedIndex: -1,
      editedItem: {
        hora: "",
        paciente: "",
      },
      defaultItem: {
        hora: "",
        paciente: "",
      },
      //date: new Date().toISOString().substr(0, 10),
      //dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
      date: null,
      dateFormatted: null,
      menu: false,
      modal: false,
      menu2: false,
      prof: "",
      profs: [],
      diaSemana: null,
      on: null,
      horaTurno: "",
      entreTurno: "",
      listaTurnos: [],
      itemCopia: {
        idTurno: null,
        tiempoTurno: null,
        cantIntervalos: null,
        fechaTurnoString: null,
        idProfesional: null,
      },
      tiposTurno: [],
    };
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    date(val) {
      this.dateFormatted = this.formatDate(this.date);
    },
    refrescarPantalla() {
      this.refrescar();
    },
    prof: {
      handler(val) {
        if (val) {
          this.armarTurnos();
        }
      },
    },
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo Turno" : "Editar Turno";
    },
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
    turnosPorDia() {
      const grupos = {};

      this.listaTurnos.forEach((turno) => {
        const dia = turno.fechaTurnoString; // ej: "15/01/2026"
        if (!grupos[dia]) grupos[dia] = [];
        grupos[dia].push(turno);
      });

      return grupos;
    },
  },
  created() {
    var hoy = new Date().getDay();
    if (hoy == 0) hoy = 6;
    else hoy -= 1;
    let dias = 1000 * 60 * 60 * 24 * hoy;

    let resta = new Date().getTime() - dias;
    this.date = this.toISOLocal(new Date(resta));
    this.dateFormatted = this.formatDate(this.toISOLocal(new Date(resta)));

    this.profs = [...this.$store.state.usuario.canchas].sort((a, b) =>
      a.nombre.localeCompare(b.nombre),
    );

    if (this.$route.params.idCancha) {
      this.prof = this.$route.params.idCancha;
    } else {
      this.prof = this.profs[0].idCancha;
    }

    this.roles = this.$store.state.usuario.roles;

    axios
      .get("/Profesional/GetTiposTurno", {
        params: {
          idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
        },
      })
      .then((r) => {
        this.tiposTurno = r.data || [];
      });
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    formatDuracion(cantIntervalos, tiempoTurno) {
      const minutos = cantIntervalos * tiempoTurno;
      const horas = Math.floor(minutos / 60);
      const minutosRestantes = minutos % 60;

      if (minutosRestantes === 0) {
        return `${horas}hs`;
      } else if (minutosRestantes === 30) {
        return `${horas}hs y media`;
      } else {
        return `${horas}hs y ${minutosRestantes}min`;
      }
    },
    getDiaSemana(fechaStr) {
      const [d, m, y] = fechaStr.split("/");
      const date = new Date(y, m - 1, d);

      const dias = [
        "Domingo",
        "Lunes",
        "Martes",
        "Miércoles",
        "Jueves",
        "Viernes",
        "Sábado",
      ];

      return dias[date.getDay()];
    },
    salir() {
      router.push("/Home");
    },
    retrocederSemana() {
      let dias = 1000 * 60 * 60 * 24 * 6;
      let resta = new Date(this.date).getTime() - dias;
      this.date = this.toISOLocal(new Date(resta));
      this.dateFormatted = this.formatDate(this.toISOLocal(new Date(resta)));
      this.armarTurnos();
    },
    avanzarSemana() {
      let dias = 1000 * 60 * 60 * 24 * 8;
      let resta = new Date(this.date).getTime() + dias;
      this.date = this.toISOLocal(new Date(resta));
      this.dateFormatted = this.formatDate(this.toISOLocal(new Date(resta)));
      this.armarTurnos();
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    cobrar(item) {
      this.editedIndex = this.listaTurnos.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.showNuevoCobro = true;
    },
    cierraNuevoCobro() {
      this.showNuevoCobro = false;
    },
    allowedDates: (val) => new Date(val).getDay() === 0,
    refrescar() {
      if (this.refrescarPantalla === true) {
        this.interval = setInterval(
          () => this.armarTurnos(),
          this.$store.state.usuario.institucion.tiempoRefresco * 1000,
        );
      } else {
        clearInterval(this.interval);
      }
    },
    copiarReprogramar(item) {
      this.copiar = 1;
      this.alert = !this.alert;
      this.itemCopia.tiempoTurno = item.tiempoTurno;
      this.itemCopia.fechaTurnoString = item.fechaTurnoString;
      this.itemCopia.cantIntervalos = item.cantIntervalos;
      this.itemCopia.idTurno = item.idTurno;
      this.itemCopia.idProfesional = item.idProfesional;
    },
    cancelaCopia() {
      this.alert = !this.alert;
      this.copiar = 0;
      this.itemCopia.tiempoTurno = null;
      this.itemCopia.fechaTurnoString = null;
      this.itemCopia.cantIntervalos = null;
      this.itemCopia.idTurno = null;
      this.itemCopia.idProfesional = null;
    },
    armarTurnos() {
      this.isLoading = true;
      const turnosData = {
        idProfesional: this.prof,
        fecha: this.date,
        idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
      };
      let self = this;
      axios
        .get("/Turnos/ArmarTurnosSemanaOptimizado?", {
          params: {
            idProfesional: turnosData.idProfesional,
            fecha: turnosData.fecha,
            idInstitucion: turnosData.idInstitucion,
          },
        })
        .then(function (response) {
          self.listaTurnos = response.data;
          self.isLoading = false;
        })
        .catch(function (error) {
          self.isLoading = false;
        });
    },
    validate() {
      this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    getColor(
      hora,
      paciente,
      entreTurno,
      estadoTurno,
      observacionesTurno,
      idObraSocial,
    ) {
      if (hora === "Feriado" || observacionesTurno === "Cancelación")
        return "red";
      else {
        if (paciente === "Disponible") return "green";
        else {
          if (estadoTurno === 1) {
            if (idObraSocial == 162 || idObraSocial == 91) return "black";
            else {
              if (entreTurno === 1) return "grey";
              else return "blue";
            }
          } else {
            if (estadoTurno === 2) return "orange";
            else return "purple";
          }
        }
      }
    },
    getColorFecha(diaSemana) {
      if (diaSemana.toString().substring(0, 2) == "LU") return "#aeaeae";
      if (diaSemana.toString().substring(0, 2) == "MA") return "#868686";
      if (diaSemana.toString().substring(0, 2) == "MI") return "#626262";
      if (diaSemana.toString().substring(0, 2) == "JU") return "#454545";
      if (diaSemana.toString().substring(0, 2) == "VI") return "#333333";
      if (diaSemana.toString().substring(0, 2) == "SA") return "#1f1f1f";
      if (diaSemana.toString().substring(0, 2) == "DO") return "#000000";
    },
    getColorPaciente(
      hora,
      paciente,
      entreTurno,
      estadoTurno,
      observacionesTurno,
      idObraSocial,
    ) {
      if (hora === "Feriado" || observacionesTurno === "Cancelación")
        return "red";
      else {
        if (paciente === "Disponible") return "green";
        else {
          if (estadoTurno === 1) {
            if (idObraSocial == 162 || idObraSocial == 91) return "black";
            else {
              if (entreTurno === 1) return "grey";
              else return "blue";
            }
          } else {
            if (estadoTurno === 2) return "orange";
            else return "purple";
          }
        }
      }
    },
    editarTurno(item) {
      this.editedIndex = this.listaTurnos.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.showEditarTurno = true;
    },
    nuevoTurno(item, val) {
      var desdeParte = item.fechaTurnoString.split("/");
      var desde = new Date(desdeParte[2], desdeParte[1] - 1, desdeParte[0]);
      var hoyParte = this.formatDate(
        this.toISOLocal(new Date()).substr(0, 10),
      ).split("/");
      var hoy = new Date(hoyParte[2], hoyParte[1] - 1, hoyParte[0]);
      if (desde < hoy) {
        this.$swal({
          title: "Fecha menor al día de hoy",
          text: "Cuidado, la fecha del turno es menor a la fecha actual. ¿Desea continuar igual?",
          icon: "success",
          showCancelButton: true,
          confirmButtonText: "Si",
          cancelButtonText: "No",
          showCloseButton: true,
          showLoaderOnConfirm: true,
        }).then((result) => {
          if (result.dismiss == "cancel") {
            return;
          } else {
            this.continuarNuevoTurno(item, val);
          }
        });
      } else {
        this.continuarNuevoTurno(item, val);
      }
    },
    continuarNuevoTurno(item, val) {
      if (this.copiar == 0) {
        this.editedIndex = this.listaTurnos.indexOf(item);
        this.editedItem = Object.assign({}, item);
        if (val === 0) {
          this.horaTurno = this.editedItem.hora;
          this.entreTurno = 0;
          this.showNuevoTurno = true;
        } else {
          let self = this;
          axios
            .get("/Turnos/ChequearCantMaxEt?", {
              params: {
                fecha: self.editedItem.fechaTurnoString,
                idProfesional: self.prof,
              },
            })
            .then((response) => {
              if (response.data == "ok") {
                this.horaTurno = this.calcularHora(this.editedItem.hora);
                this.entreTurno = 1;
                this.showNuevoTurno = true;
              } else {
                self.showAlert({
                  icon: "warning",
                  title:
                    "Supera la cantidad máxima de entre turnos diarios establecida para la cancha.",
                  vm: self,
                  timer: 2000,
                });
              }
            })
            .catch((error) => {});
        }
      } else {
        let self = this;
        this.$swal({
          title: "Copiar o Reprogramar",
          text: "Elija una opción. Si desea salir apriete la X",
          icon: "success",
          showCancelButton: true,
          showCloseButton: true,
          confirmButtonColor: "orange",
          cancelButtonColor: "purple",
          confirmButtonText: "Copiar",
          cancelButtonText: "Reprogramar",
        }).then((result) => {
          if (result.value) {
            const datosTurno = {
              idTurno: this.itemCopia.idTurno,
              idProfesional: this.prof,
              horaTurno: item.hora,
              diaTurno: item.fechaTurnoString,
              cantIntervalos: this.itemCopia.cantIntervalos,
              tiempoTurno: this.itemCopia.tiempoTurno,
              usuarioAlta: this.$store.state.usuario.usuario,
            };
            axios
              .get("/Turnos/CopiarTurno", {
                params: {
                  idTurno: datosTurno.idTurno,
                  idProfesional: datosTurno.idProfesional,
                  horaTurno: datosTurno.horaTurno,
                  fechaTurno: datosTurno.diaTurno,
                  cantIntervalos: datosTurno.cantIntervalos,
                  tiempoTurno: datosTurno.tiempoTurno,
                  usuarioAlta: datosTurno.usuarioAlta,
                },
              })
              .then((response) => {
                if (response.data == "Reservado") {
                  self.showAlert({
                    icon: "warning",
                    title:
                      "Disculpe, el turno acaba de ser tomado. Reserve otro por favor.",
                    vm: self,
                    timer: 2000,
                  });
                  self.armarTurnos();
                  return;
                }
                if (response.data == "Turnos Existentes") {
                  self.showAlert({
                    icon: "warning",
                    title:
                      "Existen turnos ya reservados dentro de la duración del turno que quiere reservar.",
                    vm: self,
                    timer: 2000,
                  });
                } else {
                  self.showAlert({
                    icon: "success",
                    title: "Turno copiado exitosamente.",
                    vm: self,
                    timer: 2000,
                  });
                  self.armarTurnos();
                  self.cancelaCopia();
                }
              })
              .catch((error) => {
                self.showAlert({
                  icon: "warning",
                  title: "El turno no pudo ser copiado.",
                  vm: self,
                  timer: 2000,
                });
              });
          } else {
            if (result.dismiss == "cancel") {
              const datosTurno = {
                idTurno: this.itemCopia.idTurno,
                idProfesional: this.prof,
                horaTurno: item.hora,
                diaTurno: item.fechaTurnoString,
                cantIntervalos: this.itemCopia.cantIntervalos,
                tiempoTurno: this.itemCopia.tiempoTurno,
                usuarioModi: this.$store.state.usuario.usuario,
                profesionalOriginal: this.itemCopia.idProfesional,
              };
              axios
                .get("/Turnos/ReprogramarTurno", {
                  params: {
                    idTurno: datosTurno.idTurno,
                    idProfesional: datosTurno.idProfesional,
                    horaTurno: datosTurno.horaTurno,
                    fechaTurno: datosTurno.diaTurno,
                    cantIntervalos: datosTurno.cantIntervalos,
                    tiempoTurno: datosTurno.tiempoTurno,
                    usuarioModi: datosTurno.usuarioModi,
                    profesionalOriginal: datosTurno.profesionalOriginal,
                  },
                })
                .then((response) => {
                  if (response.data == "Reprogramado") {
                    self.showAlert({
                      icon: "warning",
                      title:
                        "Disculpe, el turno acaba de ser reprogramado para otra cancha.",
                      vm: self,
                      timer: 2000,
                    });
                    self.armarTurnos();
                    return;
                  }
                  if (response.data === "Reservado") {
                    self.showAlert({
                      icon: "warning",
                      title:
                        "Disculpe, el turno acaba de ser tomado. Reserve otro por favor.",
                      vm: self,
                      timer: 2000,
                    });
                    self.armarTurnos();
                    return;
                  }
                  if (response.data == "Turnos Existentes") {
                    self.showAlert({
                      icon: "warning",
                      title:
                        "Existen turnos ya reservados dentro de la duración del turno que quiere reservar.",
                      vm: self,
                      timer: 2000,
                    });
                  } else {
                    self.showAlert({
                      icon: "success",
                      title: "Turno reprogramado exitosamente.",
                      vm: self,
                      timer: 2000,
                    });
                    self.armarTurnos();
                    self.cancelaCopia();
                  }
                })
                .catch((error) => {
                  self.showAlert({
                    icon: "warning",
                    title: "El turno no pudo ser reprogramado.",
                    vm: self,
                    timer: 2000,
                  });
                });
            }
          }
        });
      }
    },
    isMobile() {
      if (window.innerWidth < 992) {
        return true;
      } else {
        return false;
      }
    },
    mostrarColores() {
      this.showColores = true;
    },
    mostrarCronogramas() {
      this.showCronogramas = true;
    },
    calcularHora(hora) {
      var division = hora.split(":");
      var hoy = new Date();
      var fecha = new Date(
        hoy.getYear(),
        hoy.getMonth(),
        hoy.getDay(),
        division[0],
        parseInt(division[1] - 1),
      );
      var minutos = fecha.getMinutes().toString();
      if (minutos.length == 1) minutos = "0" + minutos;
      var horaNueva = fecha.getHours() + ":" + minutos;
      return horaNueva;
    },
    deleteItem(item) {
      this.$swal({
        title: "Borrar Turno",
        text: "¿Desea borrar el turno?",
        icon: "success",
        background: "#ececec",
        showClass: { popup: "animate__animated animate__fadeInDown" },
        hideClass: { popup: "animate__animated animate__fadeOutUp" },
        showCancelButton: true,
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then(async (result) => {
        if (!result.value) return;

        if (item.esTurnoFijo) {
          // Abrir modal de motivo de baja
          this.turnoABorrar = item;
          this.showModalMotivoBaja = true;
        } else {
          this.ejecutarBorrado(item, null);
        }
      });
    },
    ejecutarBorrado(item, motivoAusencia) {
      const idTurno = item.idTurno;
      let self = this;
      axios
        .get("/Turnos/BorrarTurno?", {
          params: {
            idTurno: idTurno,
            usuario: this.$store.state.usuario.usuario,
            ...(motivoAusencia && { motivoAusencia }),
          },
        })
        .then((response) => {
          self.showAlert({
            icon: "success",
            title: "Turno borrado.",
            vm: self,
            timer: 2000,
          });
          setTimeout(self.armarTurnos(), 1700);
        })
        .catch((error) => {
          self.showAlert({
            icon: "warning",
            title: "El turno no pudo ser borrado.",
            vm: this,
            timer: 2000,
          });
        });
    },
    confirmarMotivoBaja(motivo) {
      this.showModalMotivoBaja = false;
      if (this.turnoABorrar) {
        this.ejecutarBorrado(this.turnoABorrar, motivo);
        this.turnoABorrar = null;
      }
    },
    cerrarModalMotivoBaja() {
      this.showModalMotivoBaja = false;
      this.turnoABorrar = null;
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [month, day, year] = date.split("/");
      return `${day.padStart(2, "0")}-${month.padStart(2, "0")}-${year}-`;
    },
    toISOLocal(d) {
      var z = (n) => ("0" + n).slice(-2);
      var zz = (n) => ("00" + n).slice(-3);
      var off = d.getTimezoneOffset();
      var sign = off < 0 ? "+" : "-";
      off = Math.abs(off);
      return (
        d.getFullYear() +
        "-" +
        z(d.getMonth() + 1) +
        "-" +
        z(d.getDate()) +
        "T" +
        z(d.getHours()) +
        ":" +
        z(d.getMinutes()) +
        ":" +
        z(d.getSeconds()) +
        "." +
        zz(d.getMilliseconds()) +
        "Z"
      )
        .toString()
        .substr(0, 10);
    },
    turnoRegistrado() {
      this.armarTurnos();
      setTimeout(this.cerrarVentana, 600);
    },
    cerrarVentana() {
      this.showNuevoTurno = false;
    },
    turnoModificado() {
      this.armarTurnos();
      setTimeout(this.cerrarVentanaModificar, 600);
    },
    cerrarVentanaModificar() {
      this.showEditarTurno = false;
    },
    showAlert(alertInfo) {
      showAlert(alertInfo);
    },
    formatDuracion(cantIntervalos, tiempoTurno) {
      const minutos = cantIntervalos * tiempoTurno;
      return this.formatMinutos(minutos);
    },
    formatMinutos(minutos) {
      const horas = Math.floor(minutos / 60);
      const minutosRestantes = minutos % 60;
      if (horas === 0) return `${minutosRestantes}min`;
      else if (minutosRestantes === 0) return `${horas}hs`;
      else if (minutosRestantes === 30) return `${horas}hs y media`;
      else return `${horas}hs ${minutosRestantes}min`;
    },
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  },
  components: {
    EditarTurno,
    NuevoTurno,
    Colores,
    VerCronogramas,
    ConsumosWrapper,
    ModalMotivoBaja,
  },
};
</script>

<style scoped>
:deep(.duracion-chip) {
  border-radius: 5px !important;
  color: black !important;
  padding: 0.8rem !important;
  font-size: 14px !important;
}
:deep(.duracion-chip .v-chip__content) {
  color: black !important;
  font-size: 14px !important;
}
</style>
